var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    className: "w-10",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.8,156.8H39.2v-46.3c0-1.6,1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8v40.6h110.1v-40.6c0-1.6,1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8v46.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,134.2h0c-.8,0-1.5-.3-2-.8l-31.2-31.2c-.9-.9-1.1-2.2-.5-3.3.6-1.1,1.7-1.7,3-1.5l13.4,2.2v-53.5c0-1.6,1.3-2.8,2.8-2.8h29c1.6,0,2.8,1.3,2.8,2.8v53.5l13.4-2.2c1.2-.2,2.4.4,3,1.5.6,1.1.4,2.4-.5,3.3l-31.2,31.2c-.5.5-1.3.8-2,.8ZM77.1,104.4l22.9,22.9,22.9-22.9-7.9,1.3c-.8.2-1.7,0-2.3-.6s-1-1.3-1-2.2v-54.1h-23.3v54.1c0,.8-.4,1.6-1,2.2-.6.5-1.4.8-2.3.6l-7.9-1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.3e5678079a48c5d5c952b4ee9fa8ef12.svg";
export { ForwardRef as ReactComponent };